import script from "./ShowComptable.vue?vue&type=script&setup=true&lang=js"
export * from "./ShowComptable.vue?vue&type=script&setup=true&lang=js"

import "./ShowComptable.vue?vue&type=style&index=0&id=58e43576&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-58e43576"]])

export default __exports__